import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from '@react-pdf/renderer';
import {
  logoSanlamBase64,
  newLogoSanlamBase64,
} from 'components/DesignationLetter/constants';
import moment from 'moment';
import RobotoBold from 'fonts/Roboto-Medium.ttf';
import RobotoRegular from 'fonts/Roboto-Regular.ttf';
import RobotoItalic from 'fonts/Roboto-Italic.ttf';
import RobotoBoldItalic from 'fonts/Roboto-BoldItalic.ttf';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

const styles = StyleSheet.create({
  page: {
    padding: '30px 30px 10px 30px',
    fontSize: 10,
    lineHeight: 1.5,
  },
  image: {
    textAlign: 'left',
    width: '130px',
    height: '30px',
    padding: '0px',
  },
  newImage: {
    textAlign: 'left',
    width: '230px',
    height: '70px',
    padding: '0px',
    marginLeft: '-25px',
  },
  underline: {
    textDecoration: 'underline',
  },
  section: {
    marginTop: 40,
    marginBottom: 20,
  },
  bodyText: {
    marginBottom: 5,
  },
  divWithBorder: {
    border: '2px solid black',
    marginBottom: 10,
    height: '100%',
    maxHeight: 100,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  smallDivWithBorder: {
    border: '2px solid black',
    marginBottom: 5,
    width: '100%',
    minWidth: 200,
    fontWeight: 'bold',
  },
  headerTitle: {
    fontSize: '13px',
    fontWeight: 800,
    fontFamily: 'Roboto',
    lineHeight: 0,
    marginLeft: 20,
    marginTop: 8,
  },
  leftText: {
    marginLeft: 30,
    marginTop: 9,
  },
  objectSection: {
    marginTop: 10,
    marginBottom: 20,
  },
  objectSpacing: {
    marginTop: 20,
  },
  rightSpacing: {
    marginRight: 10,
  },
  spacingWithLineHeight: {
    marginRight: 10,
    lineHeight: 1.5,
  },
  textWithLineHeight: {
    lineHeight: 1.5,
  },
  extraBoldText: {
    fontWeight: 'extrabold',
    fontFamily: 'Roboto',
  },
  marginText: {
    margin: 5,
  },
  spacingRight: {
    marginRight: 20,
  },
  styledText: {
    fontWeight: 'extrabold',
    fontFamily: 'Roboto',
    margin: 5,
  },
});
Font.register({
  family: 'Roboto',
  fonts: [
    { src: RobotoRegular, fontWeight: 'normal' },
    { src: RobotoBold, fontWeight: 'bold' },
    { src: RobotoItalic, fontStyle: 'italic' },
    { src: RobotoBoldItalic, fontWeight: 'bold', fontStyle: 'italic' },
  ],
});
const dateNow = moment().format('DD/MM/YYYY');

const ExpertiseDocument = (props: any) => (
  <Document>
    <Page style={styles.page}>
      <View style={styles.row}>
        <View>
          <Image
            style={
              featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
                ? styles.newImage
                : styles.image
            }
            src={
              featureService.hasFeature(FEATURES.REBRANDING_EDITIQUE)
                ? newLogoSanlamBase64
                : logoSanlamBase64
            }
          />
        </View>
        <View>
          <Text style={styles.headerTitle}>Rapport d'expertise médicale</Text>
        </View>
        <View>
          <Text style={styles.leftText}>Casablanca, le {dateNow}</Text>
        </View>
      </View>
      <View style={styles.objectSection}>
        <View style={styles.objectSpacing}>
          <Text>
            Accident du : {moment(props.data.lossDate).format('DD/MM/YYYY')}
          </Text>
        </View>
        <View style={styles.objectSpacing}>
          <Text>V/références : {props.data.claimNumber}</Text>
        </View>
        <View style={styles.objectSpacing}>
          <Text>N/Références : {props.data.reference}</Text>
        </View>
      </View>
      <View style={[styles.section]}>
        <View style={styles.bodyText}>
          <Text style={{ lineHeight: 1 }}>
            Je soussigné , {props.data?.expertInfo?.ItemDescription} certifie
            avoir examiné ce jour dans le cadre d'une transaction nommé{' '}
            {props.data?.victimName},victime d'un accident de la circulation
            survenu le : {moment(props.data.lossDate).format('DD/MM/YYYY')}
          </Text>
        </View>
        <View style={styles.row}>
          <View style={styles.rightSpacing}>
            <View style={styles.row}>
              <Text style={styles.spacingWithLineHeight}>Nom :</Text>
              <Text style={styles.textWithLineHeight}>
                {props.data?.lastName}
              </Text>
            </View>
          </View>
          <View style={styles.rightSpacing}>
            <View style={styles.row}>
              <Text style={styles.spacingWithLineHeight}>Prénom :</Text>
              <Text style={styles.textWithLineHeight}>
                {props.data?.firstName}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.rightSpacing}>
            <View style={styles.row}>
              <Text style={styles.spacingWithLineHeight}>Profession :</Text>
              <Text style={styles.textWithLineHeight}>
                {props.data?.victimProfession}
              </Text>
            </View>
          </View>
          <View style={styles.rightSpacing}>
            <View style={styles.row}>
              <Text style={styles.spacingWithLineHeight}>CIN :</Text>
              <Text style={styles.textWithLineHeight}>
                {props.data?.cinVictim}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.rightSpacing}>
            <View style={styles.row}>
              <Text style={styles.spacingWithLineHeight}>
                Date de naissance :
              </Text>
              <Text style={styles.textWithLineHeight}>
                {props.data?.birthDateVictim}
              </Text>
            </View>
          </View>
          <View style={styles.rightSpacing}>
            <View style={styles.row}>
              <Text style={styles.spacingWithLineHeight}>
                Avocat/ Tuteur légal :
              </Text>
              <Text>{props.data?.tutorFullName}</Text>
            </View>
          </View>
        </View>

        <View style={styles.bodyText}>
          <Text style={[styles.underline, styles.extraBoldText]}>
            Documents remis :
          </Text>
        </View>
        <View style={styles.divWithBorder}>
          <Text style={styles.marginText}>
            Certificat initial/Certificat de consolidation/Certificat de
            prolongation/Doleances : {props.data?.certificat}
          </Text>
        </View>
        <View style={styles.divWithBorder}>
          <Text style={styles.marginText}>
            Examen Clinique : {props.data?.examination}
          </Text>
        </View>
        <View style={styles.divWithBorder}>
          <Text style={styles.marginText}>Lésion : {props.data?.lesion}</Text>
        </View>
        <View style={styles.bodyText}>
          <Text style={styles.extraBoldText}>EXAMEN :</Text>
        </View>
        <View style={styles.row}>
          <View style={styles.spacingRight}>
            <View style={styles.smallDivWithBorder}>
              <Text style={styles.styledText}>I.T.T : {props.data?.itt}</Text>
            </View>
          </View>
          <View style={styles.spacingRight}>
            <View style={styles.smallDivWithBorder}>
              <Text style={styles.styledText}>I.P.P : {props.data?.ipp}</Text>
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.spacingRight}>
            <View style={styles.smallDivWithBorder}>
              <Text style={styles.styledText}>
                Pretium Doloris : {props.data?.pretium}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.spacingRight}>
            <View style={styles.smallDivWithBorder}>
              <Text style={styles.styledText}>
                Préjudices Esthétique : {props.data?.prejudice}
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.spacingRight}>
            <View style={styles.smallDivWithBorder}>
              <Text style={styles.styledText}>
                Autres Préjudices : {props.data?.otherPrejudice}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ marginTop: 5 }}>
          <Text>
            {
              "-A- Conformément au Dahir portant loi N°1-84-177 du 02 Octobre 1984 relatif à l'indemnisation des victimes d'accident causés par des véhicules terrestres à moteurs & au décret n° 2-84-744 du 14/01/1985 relatif au bérme fonctionnel des capacités"
            }
          </Text>
        </View>
      </View>
    </Page>
  </Document>
);

export default ExpertiseDocument;
